<template>
  <div id="sr-questionnaire">
    <VerticalCards
      v-if="!loadingQuestionnaire && layout === 'vertical-cards' && questionnaireIsActive"
      :has-finished-questionnaire="hasFinishedQuestionnaire"
    />

    <HorizontalCards
      v-if="!loadingQuestionnaire && layout === 'horizontal-cards' && questionnaireIsActive"
      :has-finished-questionnaire="hasFinishedQuestionnaire"
    />

    <div class="loader" v-if="loadingQuestionnaire">
      Loading ...
    </div>

    <div class="private-questionnaire-info" v-if="!loadingQuestionnaire && !questionnaireNotFound && !$store.state.settings.active">
      <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 0 24 24" width="48"><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/></svg>
      この診断ケースはプライベートです。
    </div>

    <div class="private-questionnaire-info" v-if="!loadingQuestionnaire && !questionnairePeriodIsActive">
      {{questionnairePeriodNotActiveMessage}}
    </div>

    <div class="private-questionnaire-info" v-if="!loadingQuestionnaire && questionnaireNotFound">
      We couldn't load this questionnaire.
    </div>
  </div>
</template>

<script>
import { db } from './firebase.js'
import { mapActions } from 'vuex'

import VerticalCards from './views/VerticalCards'
import HorizontalCards from './views/HorizontalCards'

export default {
  name: 'App',
  props: {
    userId: {
      type: String
    },
    questionnaireId: {
      type: String
    }
  },
  components: {
    VerticalCards,
    HorizontalCards
  },
  data () {
    return {
      layout: 'vertical-cards',
      loadingQuestionnaire: true,
      questionnaireNotFound: false
    }
  },
  computed: {
    hasFinishedQuestionnaire () {
      if (this.$store.state.step >= this.$store.state.questions.length) {
        this.$store.dispatch('sendReport')
        return true
      }
      return false
    },
    questionnairePeriodIsActive () {
      if (this.$store.state.settings.timeLimited) {
        const now = new Date()
        const startDate = new Date(this.$store.state.settings.startDateTime)
        const endDate = new Date(this.$store.state.settings.endDateTime)
        if (now < startDate || now > endDate) {
          return false
        }
      }
      return true
    },
    questionnaireIsActive () {
      if (this.questionnairePeriodIsActive) {
        if (this.$store.state.settings.active) {
          return true
        }
      }
      return false
    },
    questionnairePeriodNotActiveMessage () {
      if (!this.questionnairePeriodIsActive) {
        const now = new Date()
        const startDate = new Date(this.$store.state.settings.startDateTime)
        const endDate = new Date(this.$store.state.settings.endDateTime)
        if (now < startDate) {
          console.log(this.$store.state.settings)
          return this.$store.state.settings.messageBeforeCampaignStart
        }
        if (now > endDate) {
          return this.$store.state.settings.messageAfterCampaignEnd
        }
      }
      return false
    }
  },
  methods: {
    ...mapActions([
      'updateQuestionnaireId',
      'updateOwnerId',
      'updateSettings',
      'updateProducts',
      'updateQuestions',
      'updateStep'
    ])
  },
  created: function () {
    db.collection('questionnaires')
      .doc(this.questionnaireId)
      .get()
      .then((doc) => {
        if (doc.exists) {
          const questionnaire = doc.data()
          this.updateQuestionnaireId(doc.id)
          this.updateOwnerId(questionnaire.ownerId)
          this.updateSettings(questionnaire.settings)
          this.updateProducts(questionnaire.products)
          this.updateQuestions(questionnaire.questions)
          this.updateStep({ step: 0 })
          this.loadingQuestionnaire = false
          if (questionnaire.settings.layout) {
            this.layout = questionnaire.settings.layout
          }
        } else {
          this.questionnaireNotFound = true
          this.loadingQuestionnaire = false
        }
      })
  },
  mounted () {
    const questionnaireRenderedEvent = new CustomEvent('questionnaire-rendered', {
      detail: this.questionnaireId
    })
    document.dispatchEvent(questionnaireRenderedEvent)
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@400;800&display=swap');

#sr-questionnaire, .sr-questionnaire {
  .background {
    position: absolute;
    z-index: -9;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .loader {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .private-questionnaire-info {
    svg {
      display: block;
      margin: auto;
      margin-bottom: 28px;
      opacity: 0.6;
    }
  }
}
</style>
